export const useFormatNumber = () => {
    const formatNumber = (number: number): string => {
        if (number === undefined) return 'unknown';
        if (number >= 1000000) {
            return (number / 1000000).toFixed(1).replace('.0', '') + 'mln'
        } else if (number >= 1000) {
            return (number / 1000).toFixed(1).replace('.0', '') + ' tys.'
        } else {
            return number.toString()
        }
    }

    return {formatNumber}
}
